import axios from 'axios';
import store from '@/store'

const baseUrl = process.env.VUE_APP_BASE_API; 
const reqpost = (method, url, params) => {
    // 优先使用 store 中的 token，如果没有则使用 localStorage
    const token = store.getters.token || localStorage.getItem('logintoken') || sessionStorage.getItem('userToken');
    return axios({
        method: method,
        url: baseUrl+url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: token
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
export {
    reqpost,
}